export default "__VITE_PUBLIC_ASSET__51788548__"